import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import AboutSection from './components/AboutSection';
import ArticlePreview from './components/ArticlePreview';
import CtaSection from './components/CtaSection';

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "KakobuyFinds",
  "url": "https://kakobuyfinds.autos",
  "inLanguage": "pl-PL",
  "description": "Kakobuy Spreadsheet Polska – przewodnik po najlepszych Kakobuy Finds, produktach i poradnikach zakupowych."
};

const webpageSchema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "Kakobuy Spreadsheet Polska 2026 – Najlepsze Kakobuy Finds i Lista Produktów",
  "description": "Poznaj Kakobuy Spreadsheet Polska. Znajdź najlepsze Kakobuy Finds, produkty, linki i poradniki zakupowe. Kompletny przewodnik dla osób kupujących z Chin.",
  "url": "https://kakobuyfinds.autos/",
  "inLanguage": "pl-PL",
  "isPartOf": { "@type": "WebSite", "name": "KakobuyFinds", "url": "https://kakobuyfinds.autos" }
};

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <CategoryGrid />
        <AboutSection />
        <ArticlePreview />
        <CtaSection />
      </main>
      <Footer />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}></script>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(webpageSchema) }}></script>
    </>
  );
}